import { render } from "./SkillsView.html?vue&type=template&id=5e018888&scoped=true&external"
import script from "./SkillsView.js?vue&type=script&lang=js&external"
export * from "./SkillsView.js?vue&type=script&lang=js&external"

import "./SkillsView.css?vue&type=style&index=0&id=5e018888&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e018888"]])

export default __exports__